import { render, staticRenderFns } from "./newTrip.vue?vue&type=template&id=0cc4f460&scoped=true&"
import script from "./newTrip.vue?vue&type=script&lang=js&"
export * from "./newTrip.vue?vue&type=script&lang=js&"
import style0 from "./newTrip.vue?vue&type=style&index=0&id=0cc4f460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc4f460",
  null
  
)

/* custom blocks */
import block0 from "./newTrip.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports